/** The file types an attachment row draws its own icon for. */
export type AttachmentFileType =
  | 'xls'
  | 'csv'
  | 'pdf'
  | 'png'
  | 'jpg'
  | 'image'
  | 'doc'
  | 'ppt'
  | 'zip'
  | 'text'
  | 'html'
  | 'other';

const BY_EXTENSION: Record<string, AttachmentFileType> = {
  xlsx: 'xls',
  xls: 'xls',
  xlsm: 'xls',
  csv: 'csv',
  pdf: 'pdf',
  png: 'png',
  jpg: 'jpg',
  jpeg: 'jpg',
  gif: 'image',
  webp: 'image',
  bmp: 'image',
  tif: 'image',
  tiff: 'image',
  doc: 'doc',
  docx: 'doc',
  ppt: 'ppt',
  pptx: 'ppt',
  zip: 'zip',
  txt: 'text',
  htm: 'html',
  html: 'html',
};

/**
 * Which icon an attachment gets.
 *
 * Extension first, MIME as the fallback — the reverse of `attachmentKind`, on
 * purpose: inbound attachments routinely arrive as `application/octet-stream`,
 * and the extension is what tells a reviewer at a glance which file is the
 * workbook.
 */
export function attachmentFileType(
  mimeType: string | null | undefined,
  fileName: string,
): AttachmentFileType {
  const ext = /\.([a-z0-9]+)$/i.exec(fileName)?.[1]?.toLowerCase();
  const byExt = ext ? BY_EXTENSION[ext] : undefined;
  if (byExt) return byExt;

  const mime = (mimeType ?? '').toLowerCase();
  if (mime.includes('spreadsheet') || mime.includes('excel')) return 'xls';
  if (mime.includes('pdf')) return 'pdf';
  if (mime === 'image/png') return 'png';
  if (mime === 'image/jpeg') return 'jpg';
  if (mime.startsWith('image/')) return 'image';
  if (mime === 'text/csv') return 'csv';
  return 'other';
}
